<template>
  <div>
    <p class="h5 mb-2">
      <b-icon
          icon="plus-circle-fill"
          @click="handleToggleSideBar"
      />
      Add Resource
    </p>
    <b-sidebar
        :id="sbId"
        v-model="sidebarModel"
        backdrop-variant="warning"
        sidebar-class="border-right"
        right
        shadow
        width="50%"
    >
      <template #header>
              <span
                  @click="handleCloseSideBar">
          <svg
              class="float-right"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                  d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
                  fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                    width="14.2222"
                    height="14.2222"
                    fill="white"
                    transform="translate(8.88867 8.88892)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
      </template>
      <b-card
          title="Add A Resource"
          class="add-publishing"
          style="height:100vh"
          no-body
      >
        <b-tabs pills card>
          <b-tab title="Resource Meta" active>
            <div id="resource-meta">
              <b-row>
                <b-col>
                  <b-form-group>
                    <label-info
                        id="resource-title"
                        label-name="Title"
                        label-info="Use the name on the front of the document"
                    />
                    <b-form-input
                        id="input-1"
                        v-model="form.title"
                        type="text"
                        placeholder="Doctor's Visit Checklist ... "
                    />
                  </b-form-group>
                  <drop-down-field
                      field-key="type"
                      field-name="Resource Type"
                      :options-json="optionsJSON"
                      select-word="Type"
                      :selected-value="form.type"
                      @selected-option="handleDropDownSelect"
                  />
                </b-col>
                <b-col>
                  <b-form-group
                      id="fieldset-1"
                      label-for="input-1"
                  >
                    <img
                        v-if="coverURL"
                        :src="coverURL"
                        style="
                        height: 150px;
                        border: solid;
                        border-width: thin;
                        border-radius: 0px;
                        object-fit:cover
                        "
                        :alt="`${title} cover`"
                    />
                    <image-upload
                        v-else
                        ref="image-upload"
                        :img-upload-idx="idx"
                        img-upload-type="photo"
                        :storage-path="storagePathCover"
                        :max-image="1"
                        :show-edit="true"
                        :show-delete="true"
                        style="margin-left: 50px; margin-right: 50px;"
                        @img-uploaded-url="handleUploadedURLCover"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <!-- Description (REQ)-->
                  <b-form-group
                      id="input-group-1"
                      label="Notes:"
                      label-for="input-1"
                  >
                    <transition name="fadeHeight" mode="out-in">
                      <editor
                          id="textarea-default"
                          v-show="form"
                          @input="input"
                          :clear="clear"
                          :content="form.description"
                          @resetClear="resetClear"
                      />
                    </transition>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                      id="fieldset-1"
                      label-for="input-1"
                  >
                    <img
                        v-if="docURL"
                        :src="docURL"
                        style="height: 150px; border: solid; border-width: thin; border-radius: 0px; object-fit:cover"
                        :alt="`${title} document`"
                    />
                    <image-upload
                        v-else
                        ref="image-upload"
                        :img-upload-idx="idx"
                        img-upload-type="photo"
                        :storage-path="storagePathDoc"
                        :max-image="1"
                        :show-edit="true"
                        :show-delete="true"
                        style="margin-left: 50px; margin-right: 50px;"
                        @img-uploaded-url="handleUploadedURLDoc"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
             </div>
          </b-tab>
          <b-tab title="Detail Page">
            <div id="detail-page">
              <b-row>
                <b-col>
                  <b-form-group
                      id="fieldset-1"
                      label-for="input-1"
                  >
                    <img
                        v-if="pageDetailImgURL"
                        :src="pageDetailImgURL"
                        style="height: 150px; border: solid; border-width: thin; border-radius: 0px; object-fit:cover"
                        :alt="`${title} detail page image`"
                    />
                    <image-upload
                        v-else
                        ref="image-upload"
                        :img-upload-idx="idx"
                        img-upload-type="photo"
                        :storage-path="storagePathDetailImg"
                        :max-image="1"
                        :show-edit="true"
                        :show-delete="true"
                        style="margin-left: 50px; margin-right: 50px;"
                        @img-uploaded-url="handleUploadedURLDetailImg"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <label-info
                        id="resource-title"
                        label-name="Headline"
                        label-info="Use the name on the front of the document"
                    />
                    <b-form-input
                        id="input-1"
                        v-model="form.title"
                        type="text"
                        placeholder="Doctor's Visit Checklist ... "
                    />
                  </b-form-group>
                  <!-- Description (REQ)-->
                  <b-form-group
                      id="input-group-1"
                      label="Notes:"
                      label-for="input-1"
                  >
                    <transition name="fadeHeight" mode="out-in">
                      <editor
                          id="textarea-default"
                          v-show="form"
                          @input="input"
                          :clear="clear"
                          :content="form.description"
                          @resetClear="resetClear"
                      />
                    </transition>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr />
            </div>
          </b-tab>
          <b-tab title="Access Page">
            <b-card-text>Detail Page</b-card-text></b-tab>
        </b-tabs>
      </b-card>
      <template #footer>
        <b-button
            class="float-right"
            variant="primary"
            @click="handleAddResource"
            style="height:50px; margin: 25px"
        >
          Add Resource
        </b-button>
      </template>
      <div></div>
    </b-sidebar>
  </div>
</template>
<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import LabelInfo from "@/components/common/labelInfo";
import DropDownField from "@/components/common/dropDownField";
import UploadImage from "@/mixins/UploadImage";
import ImageUpload from "@/components/common/imageUpload";
import Editor from "@/components/common/editor";
import optionsJSON from "../assets/options.json"

export default {
  name: "Admin_Resource_AddEditForm",
  mixins: [UploadImage],
  components: {
    Editor,
    ImageUpload,
    LabelInfo,
    DropDownField
  },
  props: {
    sbId: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: () => [],
      required: false
    },
  },
  created() {},
  mounted() {
    this.resetForm();
    this.form._created_at = new Date();
    let createdBy = this.form._created_by;
    createdBy.uid = this.profile ? this.profile.userId : "XTETE";
    createdBy.name = `${this.profile.firstname} ${this.profile.lastname}`;
    createdBy.imgURL = this.profile.imgURL;
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile",
    }),
    title() {
      return this.form && this.form.title ? this.form.title: null;
    },
    coverURL() {
      return this.form && this.form.imgURL ? this.form.imgURL: null;
    },
    docURL() {
      return this.form && this.form.docURL ? this.form.docURL: null;
    },
    pageDetailImgURL() {
      return this.form && this.form.pageDetails && this.form.pageDetails.imgURL  ?
          this.form.pageDetails.imgURL : null;
    },
  },
  methods: {
    handleToggleSideBar() {
      this.sidebarModel = !this.sidebarModel;
    },
    handleUploadedURLCover(idx, url) {
      this.form.imgURL = url;
    },
    handleUploadedURLDoc(idx, url) {
      this.form.docURL = url;
    },
    handleUploadedURLDetailImg(idx, url) {
      this.form.pageDetails.imgURL = url;
    },
    resetForm() {
      this.form = null;
      this.form = _.clone(this.defaultForm);
    },
    input(val) {
      this.form.note = val.content;
    },
    handleDropDownSelect({key, option}){
       this.form[key] = option.value;
    },
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.sidebarModel= false;
     // this.$emit("close-clicked");
    },
    resetClear() {
      this.clear = false;
    },
    profileBy() {
      return {
        uid: this.profile.userId,
        name: `${this.profile.firstname} ${this.profile.lastname}`,
        imgURL: this.profile.imgURL
      };
    },
    handleAddResource(){
      let updatedBy = this.profileBy();

      this.$store.dispatch("admin/addAdminData",
          {
            adminDataObject: this.form,
            key:'resources',
            createdBy: updatedBy
          }
      ).then(resources => {
        console.log(resources);
      });
    }
  },
  data() {
    return {
      production: true,
      optionsJSON,
      sidebarModel: false,
      callStarted: false,
      duration: 0,
      /*** TIME ***/
      timePolling: null,
      currentTime: Date.now(),
      changes: null,
      /*** TIME****/
      idx: 0,
      storagePathCover: "admin_resources_cover",
      storagePathDoc: "admin_resources_doc",
      storagePathDetailImg: "admin_resources_detail_img",
      clear: false,
      form: {},
      defaultForm: {
        _created_at: 1234,
        title: "",
        type: "",
        description:"",
        imgURL:"",
        docURL:"",
        status: "",
        pageDetails:{
          imgURL:""
        },
        _created_by: {
          uid: "",
          name: "",
          imgURL: "",
          relation: ""
        }
      },
      /* SLIDE INFO*/
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.optional2 {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  p {
    margin-left: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #474d52;
    margin: 0;
    margin-left: 16px;
    span {
      padding-left: 8px;
    }
  }
}
.toggler {
  position: relative;
  display: inline-block;
  width: 46.5px;
  height: 24px;
  background: #f3f6f9;
  border-radius: 18px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  cursor: pointer;
  @media (max-width: 590px) {
    margin-left: 15px;
  }
}
.slider {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #b3c2cb;
  box-shadow: 0px 3px 9px #c4c4c4;

  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}
.bg {
  background: rgba(85, 126, 251, 0.1);
}
.btns {
  left: 50%;
  background: var(--theme-color);
  box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
}
</style>
